import KiccEasyCardApi from '@apis/easyCard/KiccEasyCardApi';
import kiccEasyCardQueries from '@apis/queries/kiccEasyCardQueries';
import useIsBioDevice from '@hooks/easyCard/useIsBioDevice';
import useDeviceId from '@hooks/native/useDeviceId';
import useLoading from '@hooks/ui/useLoading';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@stackflow/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

function useBioDevice() {
    const deviceId = useDeviceId();
    const isBioDevice = useIsBioDevice();
    const { data: cards } = useQuery(kiccEasyCardQueries.list());
    const { push } = useFlow();
    const queryClient = useQueryClient();
    const { startLoading, stopLoading } = useLoading();

    const { mutate } = useMutation({
        mutationFn: KiccEasyCardApi.deleteBioDevice,
        onMutate() {
            startLoading();
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: kiccEasyCardQueries.bioDevice._def });
        },
        onSettled() {
            stopLoading();
        },
        onError(e: AxiosError<ErrorResponse>) {
            console.error(e);
            toast.error('등록 해제 중 오류가 발생했어요.');
        },
    });

    const toggleBioDevice = () => {
        // 현재 기기일 경우 제거
        if (isBioDevice) {
            if (deviceId) {
                mutate(deviceId);
            }
        } else if (cards) {
            // PIN이 아직 없으면 최초 등록과 같이 PIN부터 등록하고,
            // 있으면 PIN을 한 번 확인한 뒤 이 기기를 등록한다
            push('EasyCardPinActivity', {
                mode: cards.isPinRegistered ? 'bioDevice' : undefined,
            });
        }
    };

    return {
        isBioDevice,
        toggleBioDevice,
    };
}

export default useBioDevice;
